import { StoreInterface } from '@Src/app/types';
import { useDispatch, useSelector } from 'react-redux';
import { setRgs } from '@Modal/reducers/general/generalSlice';

export const useGeneral = () => {
  const dispatch = useDispatch();
  const { rgs } = useSelector((state: StoreInterface) => state?.general);

  const handleRgsChange = (rgs: 'EU' | 'EU2' | 'AS' | 'AS1' | 'SA' | 'AF' | 'AF1' | 'AF2' | 'AF3') => {
    dispatch(setRgs(rgs));
  };

  return {
    // State
    rgs,
    // Actions
    setRgs,
    // Handlers
    handleRgsChange,
  };
};
